import {
  FormsFollowOrderTypes,
  FormsSubmissionsLevelsTypesEnum,
} from "../enums";
import {HttpServices} from "../Helpers";

export const GetOnboardingFlowURL = async ({
  uuid,
  email,
  forType,
  editor_role,
  role_type,
  type_of_submission = FormsSubmissionsLevelsTypesEnum.FormLevel.key,
  follow_order = FormsFollowOrderTypes.No.key,
  company_uuid,
}) => {
  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/onboarding/${process.env.REACT_APP_VERSION_API}/get-member-flow`,

    {
      params: {
        uuid,
        email,
        for: forType,
        editor_role,
        type_of_submission,
        follow_order,
        role_type,
      },
      headers:
        (company_uuid && {
          "Accept-Company": company_uuid,
        }) ||
        undefined,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
export const GetAllOnboardingMembers = async ({
  limit,
  page,
  search,
  status = true,
  use_for = "dropdown",
  other_than,
  with_than,
  space_uuid,
  folder_uuid,
  company_uuid,
  user_uuid,
  member,
  sort_by,
  order,
}) => {
  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/onboarding/${process.env.REACT_APP_VERSION_API}/members`,

    {
      params: {
        limit,
        page,
        query: search,
        status,
        use_for,
        space_uuid,
        folder_uuid,
        with_than,
        other_than,
        user_uuid,
        member,
        sort_by,
        order,
      },
      headers:
        (company_uuid && {
          "Accept-Company": company_uuid,
        }) ||
        undefined,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
export const GetOnboardingResponsesAssignedToView = async ({
  limit,
  page,
  search,
  status,
  use_for = "dropdown", // can be list (with not active spaces) or menu (without pagination)
  is_with_disconnected_flows = false,
  other_than,
  with_than,
  group_by,
  sort_by,
  member,
  task,
  user_uuid,
  order,
  // company_uuid,
}) => {
  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/onboarding/${process.env.REACT_APP_VERSION_API}/responses/assigned-to-view`,

    {
      params: {
        limit,
        page,
        query: search,
        status,
        use_for,
        is_with_disconnected_flows,
        with_than,
        other_than,
        group_by,
        sort_by,
        member,
        task,
        user_uuid,
        order,
      },
      // headers:
      //   (company_uuid && {
      //     'Accept-Company': company_uuid,
      //   })
      //   || undefined,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
